import React from "react";

const API = process.env.REACT_APP_API_URL || "";

function LoginPage() {
  return (
    <div className="lp">
      {/* Animated background layers */}
      <div className="lp-bg-mesh" />
      <div className="lp-blob" />

      {/* Subtle data pattern - flowing binary/hex */}
      <div className="lp-data-rain">
        {[...Array(12)].map((_, i) => (
          <div key={i} className="lp-data-col" style={{
            left: `${5 + i * 8}%`,
            animationDuration: `${12 + i * 3}s`,
            animationDelay: `${-i * 2}s`,
            opacity: 0.06 + (i % 3) * 0.02,
          }}>
            {["01", "10", "∑", "λ", "π", "∂", "∫", "Δ", "→", "⊕", "∞", "≈"][i % 12]}
            {["11", "00", "μ", "σ", "Ω", "∇", "⊗", "≡", "⟨", "⟩", "∀", "∃"][(i + 3) % 12]}
          </div>
        ))}
      </div>

      {/* Pulse rings */}
      <div className="lp-pulse-rings">
        <div className="lp-ring lp-ring-1" />
        <div className="lp-ring lp-ring-2" />
        <div className="lp-ring lp-ring-3" />
      </div>

      {/* Floating nodes */}
      <div className="lp-nodes">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="lp-node" style={{
            left: `${15 + i * 14}%`,
            top: `${20 + (i % 3) * 25}%`,
            animationDelay: `${i * 1.5}s`,
          }} />
        ))}
      </div>

      {/* Connection lines SVG */}
      <svg className="lp-connections" viewBox="0 0 1000 600" preserveAspectRatio="none">
        <path className="lp-conn-line" d="M100,200 Q300,100 500,250 T900,200" />
        <path className="lp-conn-line lp-conn-2" d="M50,400 Q250,350 450,450 T850,380" />
        <path className="lp-conn-line lp-conn-3" d="M200,100 Q400,180 600,80 T950,150" />
      </svg>

      {/* Header */}
      <header className="lp-header" />

      {/* Center content */}
      <section className="lp-center">
        <h1><span className="lp-gradient-text">Automation</span> Insights</h1>
        <p>
          End-to-end observability for insurance automation workflows — pipeline performance,
          cost analytics, and operational intelligence through a unified dashboard.
        </p>
        <a href={`${API}/auth/login`} className="lp-btn-primary">
          <svg width="16" height="16" viewBox="0 0 21 21" fill="none">
            <rect width="10" height="10" fill="#f25022"/><rect x="11" width="10" height="10" fill="#7fba00"/>
            <rect y="11" width="10" height="10" fill="#00a4ef"/><rect x="11" y="11" width="10" height="10" fill="#ffb900"/>
          </svg>
          Enterprise SSO Login
        </a>
      </section>

      {/* Footer */}
      <div className="lp-footer">
        © {new Date().getFullYear()} Futuristic Underwriters Pvt Ltd
      </div>
    </div>
  );
}

export default LoginPage;
